<template>
	<transition name="scroll-y-reverse-transition" v-if="module">
		<v-row v-show="module" class="module mb-12" v-bind:class="{ 'swap-image-position': module.swapImagePosition }">
			<v-col cols="12" class="text-center">
				<div class="pulse" @click="goToDiv">
					<div>
						<v-icon class="pulse-icon" :style="{ background: module.contentBackgroundColor.color, color: module.textColor.color }" large>
							{{ module.icon }}
						</v-icon>
					</div>
					<div style="position: relative;">
						<v-icon class="bounce-arrow" color="" large>
							keyboard_arrow_down
						</v-icon>
					</div>
				</div>
			</v-col>
		</v-row>
	</transition>
</template>

<script>
export default {
	name: 'scroll-to-div-module',
	props: ['module'],
	data() {
		return {
			imgIsLoaded: false
		};
	},
	methods: {
		goToDiv() {
			const menuHeight = 80;
			const element = document.getElementById('module_' + this.module.scrollToComponentIndex);
			const elementOffsetTop = element.getBoundingClientRect().top;
			let offsetTop = (offsetTop = Math.abs(elementOffsetTop + window.scrollY) - menuHeight);
			window.scrollTo({
				top: offsetTop,
				left: 0,
				behavior: 'smooth'
			});
		}
	},
	computed: {
		hasIcon() {
			return this.module.icon;
		}
	}
};
</script>

<style lang="scss" scoped>
@import '~@/styles/variables';

.module {
	--pulse-color1: black; //rgb(191, 229, 233);
	--pulse-color2: black;
	--pulse-color3: black;
	margin-bottom: 100px;

	@media #{map-get($display-breakpoints, 'xs-only')} {
		margin-bottom: 50px;
	}

	&__text {
		h2 {
			font-size: 3rem;
			max-width: 20ch;
			line-height: 1.25;
		}

		p {
			max-width: 40ch;
		}
	}

	.pulse {
		.pulse-icon {
			animation: shadow-pulse 1s infinite;
			border-radius: 50%;
			padding: 10px;
		}
		.bounce-arrow {
			animation: bounce-up-and-down 1s infinite;
			//position: absolute;
		}
	}

	@keyframes shadow-pulse {
		0% {
			box-shadow: 0 0 0 0px rgba(0, 0, 0, 0.2);
		}
		100% {
			box-shadow: 0 0 0 15px rgba(0, 0, 0, 0);
		}
	}
	@keyframes bounce-up-and-down {
		0% {
			top: 0;
		}
		50% {
			top: 10px;
		}

		100% {
			top: 0;
		}
	}
}
</style>
